import styled from 'styled-components';
export const QuantityInnerInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  font-family: 'SF Pro Text';
  border: none;
  color: rgba(0, 0, 0, 0.87);
  &:focus {
    outline: none;
  }
`;
